/**
 * <SearchResult
 *	/>
 *
 * This is ...
 *
 *
 * @parent Header
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import locale from './locale';
import Loading from 'components/UI/Loading';
import './SearchResult.scss';
import StudentResult from './StudentResult';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => {
  return {

  };
};

class SearchResult extends React.Component {
  constructor(props) {
    super(props);

    this.onSearch = this.onSearch.bind(this);
    this.onSearching = this.onSearching.bind(this);

    this.state = {
      totalSearchedNumber: 0,
      categories: [],
      finishedCategories: 0,
    }
  }

  componentWillMount() {

  }

  onSearch(err, { searchedNumber }) {
    if (err) {
      console.error(err);
    }

    this.setState({
      totalSearchedNumber: this.state.totalSearchedNumber + searchedNumber,
      finishedCategories: this.state.finishedCategories + 1,
    });
  }

  onSearching(categoryName) {
    this.setState({
      categories: [ ...this.state.categories, categoryName, ],
    });
  }

  render() {
    const {
      searchText,
    } = this.props;

    const {
      totalSearchedNumber,
      categories = [],
      finishedCategories,
    } = this.state;

    return (
      <div className='SearchResult'>
        <div className='SearchResult--content'>
          <div className='SearchResult--title'>{__('Searching for "{searchText}"', locale, { searchText })} ({totalSearchedNumber} result(s) found) </div>
          <StudentResult searchText={searchText} onSearching={this.onSearching} onSearch={this.onSearch} />
        </div>
        { finishedCategories < categories.length && <div className='SearchResult--loading'>
          <Loading type='facebook' />
        </div> }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult);



// WEBPACK FOOTER //
// ./src/containers/Main/SearchResult/index.js